export default "__VITE_ASSET__e3e58574__"